<template>
  <v-container fluid>

    <v-layout>
      <v-flex lg12>
        <h2>Options Statistics</h2>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs5 md2>
        <v-menu
          ref="startMenu"
          :close-on-content-click="true"
          v-model="startMenu"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="formattedStartDate"
            label="Start Date"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="formattedStartDate"
            no-title
            :show-current="false"
            @input="updateDates()"
            scrollable
          >
          </v-date-picker>
        </v-menu>
      </v-flex>

      <v-flex xs5 offset-xs2 md2 offset-md1>
        <v-menu
          ref="endMenu"
          :close-on-content-click="true"
          v-model="endMenu"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="formattedEndDate"
            label="End Date"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="formattedEndDate"
            no-title
            :show-current="false"
            @input="updateDates()"
            scrollable
          >
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>

    <v-layout align-center justify-start>
      <v-flex>
        <v-btn color="info" @click="getData()">Refresh</v-btn>
        <span>Last updated: {{ (lastUpdatedDiff * -1).toFixed(0) }} seconds ago</span>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex v-if="!loading" class="table-container" lg12>
        <tm-table :creator-data="creatorData" :industry-data="industryData"></tm-table>
        <am-table :sender-data="senderData" :sender-industry-data="senderIndustryData"></am-table>
        <share-table :share-options-data="shareOptionsData"></share-table>
      </v-flex>
      <v-flex v-if="loading">
        <h2>Loading...</h2>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import TmTable from './TmTable.vue';
import AmTable from './AmTable.vue';
import ShareTable from './ShareTable.vue';
import { mapState, mapActions } from 'vuex';
import { DateTime } from 'luxon';

export default {
  name: 'OptionsDashboard',
  components: {
    TmTable,
    AmTable,
    ShareTable
  },

  data() {
    return {
      formattedStartDate: null,
      formattedEndDate: null,
      endMenu: false,
      startMenu: false
    };
  },

  computed: {
    ...mapState('options', ['creatorData', 'industryData', 'senderData', 'senderIndustryData', 'shareOptionsData', 'dates', 'loading', 'lastUpdated', 'lastUpdatedDiff'])
  },

  methods: {
    ...mapActions('options', ['setDates', 'getData', 'unsetInterval']),

    updateDates() {
      this.setDates({
        startDate: DateTime.fromFormat(this.formattedStartDate, 'yyyy-LL-dd'),
        endDate: DateTime.fromFormat(this.formattedEndDate, 'yyyy-LL-dd')
      });
      this.getData();
    },

    formatDates() {
      this.formattedStartDate = this.dates.startDate.toFormat('yyyy-LL-dd');
      this.formattedEndDate = this.dates.endDate.toFormat('yyyy-LL-dd');
    }
  },

  mounted() {
    this.setDates({
      startDate: DateTime.utc().startOf('day'),
      endDate: DateTime.utc().startOf('day')
    });
    this.formatDates();
    this.getData();
  },

  destroyed() {
    this.unsetInterval();
  }
};
</script>

<style lang="scss" scoped>
  h2 {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .table-container /deep/ .elevation-1 {
    margin-bottom: 20px;
    table.table {
      tbody td, tbody th, thead tr, thead th:not(:first-child) {
        height: 32px;
        padding: 0px 8px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/reports/options/OptionsDashboard.vue